import axios from "axios";
import { authHeader } from "./authHeader";

const API_URL = process.env.REACT_APP_API_URL;

//getPlan
const getPlan = (params) => {
  return axios.get(API_URL + '/api/plan', { 
    params: params,  
    headers:authHeader()  
  });
};  

//Get Plan By Id
const getPlanById = (id) => {
  return axios.get(API_URL + `/api/plan/${id}`,{
    headers: authHeader()
  })
}

//Create Plan
const createPlan = (formData) => {
  return axios.post(API_URL + '/api/plan',formData,{
    headers: authHeader()
  })
} 

//Update Plan
const updatePlan = (id,formData) => {
  return axios.put(API_URL + `/api/plan/update/${id}`,formData,{
    headers: authHeader()
  })
}

//Delete Plan
const deletePlan = (id) => {
  return axios.delete(API_URL + `/api/plan/delete/${id}`,{
    headers: authHeader()
  })
}



const PLANAPI={
  getPlan,
  createPlan,
  updatePlan,
  deletePlan,
  getPlanById
}

export default PLANAPI;